import React from 'react';
import TopNavBar from './TopNavBar';

function Layout({ children, activePage, scrollable = true }) {
  return (
    <div className="h-screen flex flex-col">
      <div className="flex-none">
        <TopNavBar activePage={activePage} />
      </div>
      <div className={`flex-1 ${scrollable ? 'overflow-y-auto' : 'overflow-hidden'}`}>
        {children}
      </div>
    </div>
  );
}

export default Layout;
